<template>
  <el-row v-loading="!loaded">

    <el-card>
      <div
          slot="header"
          class="clearfix">
        <!--          <span style="float: left">Partners</span>-->

        <!--          <el-button style="float: right" @click="loadContact('new')">-->
        <!--            <fa icon="plus" fixed-width></fa>-->
        <!--            <fa icon="cubes" fixed-width size="lg"></fa>-->
        <!--          </el-button>-->
      </div>
      <!--      <el-row>-->
      <!--        <el-input v-model="searchall"></el-input>-->
      <!--      </el-row>-->


      <!--        <el-card>-->
      <s-form style="border:2px solid #0a4e47"
              slot="header"
              :fillHeight="false">
        <s-form-actions slot="actions">
          <sf-button
              v-if="formData.id"
              type="warning"
              confirm="This action will disable the trip"
              slot="left"
              @click="deleteData()">{{ formData.unpublished_at ? 'Publish it' : 'Unpublish it' }}
          </sf-button>
          <sf-button
              slot="middle"
              confirm="Please select (on the left) the trip that you want to copy to the meeting points. Do you want to do this?"
              style="float: right"
              size="large"
              type="success"
              @click="goCopy"
              material="content_copy"></sf-button>
          <sf-button
              type="warning"
              @click="saveData()"
              v-if="formData.id" material="done">
          </sf-button>
          <sf-button
              type="primary"
              material="add"
              @click="saveData()"
              v-else>
          </sf-button>
        </s-form-actions>

        <el-row>
          <el-col :md="5">
            <!--          <el-tab-pane-->
            <!--              label="Details"-->
            <!--              name="Details"-->
            <!--          >-->
            <s-form>
              <s-form-item :sz="24" label="Title">

                <el-input
                    v-model="formData.title"
                    label="Title"></el-input>
              </s-form-item>
              <s-form-item :sz="12" label="Year">

                <el-input v-model="formData.year"></el-input>
              </s-form-item>
              <s-form-item :sz="12" label="Capacity">

                <el-input v-model="formData.max_capacity"></el-input>
              </s-form-item>
              <s-form-item :sz="24">
                <label>Trip Start Time</label>
                <auto-timepicker v-model="formData.startTime"
                                 @change="handleTripTime"></auto-timepicker>
              </s-form-item>
              <s-form-item :sz="24" label="Trip Starting location">

                <s-remote-select
                    :safeMode="false"
                    v-model="formData.startPoint"
                    class-model="pup"
                    query-prop="q"
                    label-prop="name"
                    captionField="loc_name"
                    prefixField="typename"
                ></s-remote-select>
              </s-form-item>
              <s-form-item :sz="12" label="Meeting points time is">

                <el-switch
                    style="display: block"
                    v-model="formData.pickup_time_exact"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Exact"
                    :active-value="1"
                    :inactive-value="0"
                    inactive-text="Relative">
                </el-switch>

              </s-form-item>


              <s-form-item :sz="12" label="Display on Mobile App">

                <el-switch
                    style="display: block"
                    v-model="formData.packagescript.strictPickups"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Meeting points"

                    inactive-text="All">
                </el-switch>
                <!--                <q-checkbox-->
                <!--                    v-model="formData.packagescript.strictPickups"-->
                <!--                    icon="alarm"/>-->
              </s-form-item>
            </s-form>
            <!--          </el-tab-pane>-->
          </el-col>
          <el-col :md="19">
            <el-tabs
                type="card"
                v-model="activeTab">

              <el-tab-pane
                  label="Plan"
                  name="planner">
                <el-row v-if="activeTab=='planner'">
                  <s-form>
                    <s-form-item
                        :sz="12"
                        style="padding-bottom: 5px">
                      <label>Plan range</label>
                      <ctk-dater
                          range
                          v-model="planRange"
                          display-format="dd/MM/yyyy"
                          export-format="DD/MM/YYYY"
                          valueFormat="onurl"
                          default="2months"></ctk-dater>
                      <label>Available days on the week</label>

                      <s-general-select
                          v-model="avDays"
                          :multiple="true"
                          :options="['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']"
                          simple-options></s-general-select>
                    </s-form-item>
                    <!--                    <s-form-item :sz="8">-->
                    <!--                      <label>Trip Start Time</label>-->
                    <!--                      <auto-timepicker v-model="formData.startTime"-->
                    <!--                                       @change="$message.warning('Pickup times will change relative to the new starting time')"></auto-timepicker>-->
                    <!--                    </s-form-item>-->
                    <s-form-item
                        :sz="12"
                        v-if="planRange&&planRange.length">
                      <el-row>
                        <el-button
                            style="float: left;width: 100%"
                            size="large"
                            type="success"
                            @click="planIt()"
                            :disabled="!avDays.length"
                            title="If you are ready, this action will create all the planed trips for you"
                            icon="el-icon-video-play">Create trips
                        </el-button>
                      </el-row>
                      <el-alert :type="avDays.length?'success':'warning'"> from {{ planRange[0] }} to {{ planRange[1] }}
                        every
                        {{ avDays && avDays.length ? avDays.join(',') : ' ...please select at least one day' }}
                      </el-alert>

                    </s-form-item>
                    <s-table
                        :key="clock"
                        v-if="planRange&&planRange.length"
                        ref="tripsList"

                        :colDefinitions="colTripDefinitions"
                        modx-processor="scheduletrip/getlist"
                        @cell-change="updateTrip"
                        :r-query="qTrips"></s-table>
                  </s-form>
                </el-row>
              </el-tab-pane>

              <el-tab-pane
                  label="Pickup Points"
                  name="pupmap">
                <div
                    v-if="activeTab=='pupmap'"
                    class="with-gaps">

                  <!--              <s-form-item :sz="12">-->
                  <!--                <label>Pickup points only from this setup</label>-->
                  <!--                <q-toggle-->
                  <!--                    v-model="formData.packagescript.strictPickups"-->
                  <!--                    icon="alarm"/>-->
                  <!--              </s-form-item>-->
                  <el-row>


                    <el-col :md="12">
                      <label>Add M.Point</label>
                      <s-remote-select
                          queryProp="q"
                          classModel="pup"
                          v-model="newPupMap.pp_id"
                          labelProp="name"

                          valueProp="id"
                          :extraQueryParams="{_type: newPupMap._onlyMP?'MEETINGPOINT':null,resort:newPupMap.loc}"
                          captionField="typename"
                          prefixField="loc_name"></s-remote-select>
                    </el-col>
                    <el-col :md="6">
                      <label>P.P. Time</label>
                      <auto-timepicker

                          :offset="formData.startTime"
                          v-model="newPupMap.timeOffset"></auto-timepicker>
                    </el-col>
                    <el-col :md="4">
                      <el-button
                          style="float: right"
                          size="large"
                          type="success"
                          @click="setPupMap()"
                          icon="el-icon-plus"></el-button>
                    </el-col>

                  </el-row>
                  <!--              <el-row>-->
                  <!--                <el-button-->
                  <!--                    style="float: right"-->
                  <!--                    size="large"-->
                  <!--                    type="success"-->
                  <!--                    @click="$refs.timesMap.appendRecord()"-->
                  <!--                    icon="el-icon-plus"></el-button>-->
                  <!--              </el-row>-->
                  <s-table
                      ref="timesMap"
                      :dispalyLineNumber="true"
                      :pagging="1000"
                      :sortingProp="'sequence'"
                      :key="clock+(formData.pickup_time_exact?1:0)"
                      :colDefinitions="colPupTimesDefinitions"
                      modx-processor="tripspointsmap/getlist"
                      :r-query="{ ts_id:$route.params.serviceId,sort:'sequence',dir:'ASC',resort:newPupMap.loc,limit:0}"
                      xchangeOrder="orderChanged"
                      @cell-change="setPupMap">
                    <template #top-left>
                      <el-popover
                          placement="top-start"
                          title="Filters"
                          width="400"
                          trigger="click"
                      >

                        <el-row>

                          <s-remote-select
                              v-model="newPupMap.loc"
                              queryProp="q"
                              classModel="locations"
                              labelProp="name"
                              valueProp="id"></s-remote-select>
                        </el-row>
                        <el-row style="padding-top:5px">
                          <el-checkbox v-model="newPupMap._onlyMP">Only Meeting Points</el-checkbox>
                        </el-row>
                        <q-btn slot="reference" icon="find_in_page" type="text" title="Filter pickup points"
                               style="font-size: 1.2em"></q-btn>
                      </el-popover>
                    </template>
                  </s-table>
                </div>
              </el-tab-pane>

            </el-tabs>
          </el-col>
        </el-row>
      </s-form>


    </el-card>

  </el-row>
</template>


<script>

import _ from "lodash";

import * as api from "~/api/resource";

import SGeneralSelect from "../../Form/GeneralSelect";
import SForm from "../../Form/SForm";
import AutoTimepicker from "../../Form/AutoTimepicker";
import SfButton from "../../Form/SfButton";

export default {
  components: {SfButton, AutoTimepicker, SForm, SGeneralSelect},

  data() {
    return {
      clock: 0,
      avDays: [],
      newPupMap: {loc: null, pp_id: null, timeOffset: 0, _onlyMP: false},
      printReady: false,
      loaded: false,
      formData: {packagescript: {}},
      searchall: null,
      activeTab: 'planner',
      planRange: null,
      dateFormat: "DD/MM/YY",
    };
  },
  methods: {
    goCopy() {

      this.routeGo({query: {copy_maps: this.formData.id}})
      this.$nextTick(() => this.toggleLefPanel(true))
    },
    async handleTripTime() {

    },
    async deleteData() {
      this.pocessing = true;

      try {
        await api.removeObject("tripservice", this.formData);
        this.formData.unpublished_at = this.formData.unpublished_at ? null : 1
      } catch (error) {
        _log_("error", error);
        this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("delete", this.formData);
      this.$emit("done", null);
      this.pocessing = false;
    },
    async saveData() {
      this.pocessing = true;
      if (!this.formData.kind) this.formData.kind = 'EXCRS'
      try {
        this.formData = await api.updateProcessor(
            "tripservice/update",
            this.formData
        );
      } catch (error) {
        console.error(error);
        this.$message({
          showClose: true,
          message: error.message?.message || error.message || 'I think you are missing some data.',
          type: 'warning'
        });


        // alert(error.message);
      }

      this.$emit("update", this.formData);
      this.$emit("change", this.formData);
      this.$emit("done", this.formData);
      this.$router.replace({params: {serviceId: this.formData.id}});
      this.pocessing = false;
    },
    async planIt() {
      //
//
// action: scheduletrip/escursionplanner
      if (this.planRange && this.planRange[0] && this.planRange[1]) {
        const sent = {
          serviseId: this.formData.id,
          specificTime: 1,
          tripType: 'EXCRS',
          period: this.planRange[0] + '-' + this.planRange[1],
          startT: this.formData.startTime,
          everywhen: this.avDays.join(','),
          capacity: this.formData.max_capacity
        }
// objectId:

        const data = await api.updateProcessor("vue_scheduletrip/excursionplanner", sent);
        ++this.clock;
      }
    },
    async updateTrip(e) {
      const data = await api.updateProcessor("vue_scheduletrip", e.row);
    },
    async setPupMap(e) {
      _log_('report setPupMap', e)
      if (e) {
        e.row.ts_id = this.$route.params.serviceId
        const data = await api.updateProcessor("tripspointsmap/update", e.row);

        this.$refs.timesMap.updateRow({idx: e.row.idx}, {id: data.id})
      } else {
        this.newPupMap.ts_id = this.$route.params.serviceId
        const data = await api.updateProcessor("tripspointsmap/update", this.newPupMap);
        ++this.clock
        // this.$refs.timesMap.appendRecord(this.newPupMap)
        //{ts_id:$route.params.serviceI}
        // this.$refs.timesMap.updateRow({idx: e.row.idx}, {id: data.id})
      }
    },
    async orderChanged(orders) {
      if (orders == 'reset') {
        //tripspointsmap/getlist
        orders = await api.getModxList('tripspointsmap/getlist', {
          ts_id: this.$route.params.serviceId,
          sort: 'sequence',
          dir: 'ASC',
          limit: 0
        })
      }
      let newOrders = {}, idx = 0
      orders.forEach(row => newOrders[row.id] = ++idx)
      const data = await api.fetchProcessor('tripspointsmap/orderupdate', {
        do: 'reorder',
        orders: JSON.stringify(newOrders)
      })
      _log_("hell.UPDATE..", orders);
    },
    updateTable(msg) {

      this.$refs.tourCoList.updateOrAppendRow(msg);
    },
    loadContact(selector) {

      const id = selector.row ? selector.row.id : selector;
      this.routeGo({
        name: "contactpartner",
        params: {contactid: id},
      });
    },
  },
  watch: {
    "$route.params.serviceId": {
      handler: async function (serviceId, serviceId_old) {

        if (serviceId == serviceId_old) return
        this.loaded = false;
        if (serviceId && serviceId != 'new')
          this.formData = await api.getObject('tripservice', serviceId)
        else this.formData = {}
        if (!this.formData.packagescript) this.$set(this.formData, 'packagescript', {})
        _log_("hell...", serviceId, this.formData);
        this.loaded = true;
      },

      immediate: true
    },
  },
  async mounted() {
    // await this.orderChanged('reset')
    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    qTrips() {

      var q = {};
      if (this.planRange)
        q = {
          daterange:
              (this.planRange[0] ? this.planRange[0] : "") +
              "-" +
              (this.planRange[1] ? this.planRange[1] : ""),

          // tripType: this.workingKind
        };
      q["excrsid"] = this.$route.params.serviceId;
      // if (this.$route.query.query) q.bookingsearch = this.$route.query.query;


      return q;
    },
    colTripDefinitions() {
      const vm = this, dt = vm.$refs.tripsList
      return [
        // {
        //   prop: "paymentStatus",
        //   width: "120px",
        //   label: "Πληρωμή",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-payment"
        //   }
        // },
        // {prop: "tripName", width: "", label: "Trip"},
        {
          prop: "time",

          label: "When",
          editable: true,

          editorcomponent: {
            is: "s-dater",
            type: 'datetime'
          },
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatUnxTime(val);
          },
        },
        {
          prop: "capacity",

          editable: true,
          editorcomponent: {
            is: "s-number",

          },
          width: "120px", label: "Capacity"
        },

        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,
          async onClick(e) {
            _log_(">>QP>>", vm.$refs, dt);
            vm.$confirm(
                "This will permanently delete the record. Continue?",
                "Warning",
                {
                  confirmButtonText: "OK",
                  cancelButtonText: "Cancel",
                  type: "warning"
                }
            )
                .then(() => {

                  vm.$refs.tripsList.removeRow({idx: e.idx}, true)
                  api.removeObject("scheduletrip", {id: e.id});

                })
          },

          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }
      ];
    },
    colPupTimesDefinitions() {
      var rw = "580px",
          vm = this;
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        {

          prop: "pp_id",
          minWidth: "250px",
          label: "MeetingPoint",

          editable: true,

          editorcomponent: {
            is: "s-remote-select",

            queryProp: "q",
            classModel: "pup",
            labelProp: "name",
            valueProp: "id",
            extraQueryParams: {_type: 'MEETINGPOINT'},
            captionField: "typename",
            prefixField: "loc_name",
          },
          onChange(ev, row) {
            // _log_("is..onChange..", ev, row);
            if (ev.obj) {
              row.pp_name = ev.obj.name
              row.loc_name = ev.obj.loc_name
            }

          },
          formatter: function (val, cols, row) {
            if (!val) return 'Excursion Start'
            return val ? row.pp_name + ' @ ' + row.loc_name : 'not set'
          },
        },

        {

          prop: "alter_meeting_id",
          minWidth: "250px",
          label: "Private Meeting Point",

          editable: true,

          editorcomponent: {
            is: "s-remote-select",

            queryProp: "q",
            classModel: "pup",
            labelProp: "name",
            valueProp: "id",
            extraQueryParams: {_type: 'MEETINGPOINT'},
            captionField: "typename",
            prefixField: "loc_name",
          },
          onChange(ev, row) {
            // _log_("is..onChange..", ev, row);
            if (ev.obj) {
              row.a_pp_name = ev.obj.name
              row.a_loc_name = ev.obj.loc_name
            }

          },
          formatter: function (val, cols, row) {

            return val ? row.a_pp_name + ' @ ' + row.a_loc_name : 'not set'
          },
        },
        {
          prop: "exactTime",
          editable: true,
          editorcomponent: {
            is: "AutoTimepicker",

          },
          formatter: function (val, cols, row) {
            //           return vm.intToTime(vm.formData.startTime - Math.abs(val))
            return vm.intToTime(val)
          },
          width: "", label: "Exact Time"
        },
        {
          prop: "timeOffset",
          editable: true,
          editorcomponent: {
            is: "AutoTimepicker",
            offset: vm.formData.startTime,
          },
          formatter: function (val, cols, row) {
            //           return vm.intToTime(vm.formData.startTime - Math.abs(val))
            // if(vm.formData.pickup_time_exact)
            //   return  vm.intToTime(row.exactTime)
            return '<span title="' + vm.intToTime(row.exactTime) + '">' + vm.intToTime(val + vm.formData.startTime) + '</span>'
          },
          width: "", label: "Time"
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,
          async onClick(e) {

            vm.$confirm(
                "This will permanently delete the record. Continue?",
                "Warning",
                {
                  confirmButtonText: "OK",
                  cancelButtonText: "Cancel",
                  type: "warning"
                }
            )
                .then(() => {

                  vm.$refs.timesMap.removeRow({idx: e.idx}, true)
                  api.removeObject("tripspointsmap", {id: e.id});

                })
          },

          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
        }
      ].filter(col => {
        if (col.prop == 'timeOffset')
          return !vm.formData.pickup_time_exact
        else if (col.prop == 'exactTime')
          return vm.formData.pickup_time_exact
        return true

      });
    },
  },
};

</script>

<style>
.with-gaps div {
  padding: 2px;
}

.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}
</style>
